import api from '../api';
import { importFetchedAccounts } from './importer';

export const CHATS_FETCH_REQUEST = 'CHATS_FETCH_REQUEST';
export const CHATS_FETCH_SUCCESS = 'CHATS_FETCH_SUCCESS';
export const CHATS_FETCH_FAIL = 'CHATS_FETCH_FAIL';

export const CHAT_FETCH_REQUEST = 'CHAT_FETCH_REQUEST';
export const CHAT_FETCH_SUCCESS = 'CHAT_FETCH_SUCCESS';
export const CHAT_FETCH_FAIL = 'CHAT_FETCH_FAIL';

export const CHAT_CREATE_REQUEST = 'CHAT_CREATE_REQUEST';
export const CHAT_CREATE_SUCCESS = 'CHAT_CREATE_SUCCESS';
export const CHAT_CREATE_FAIL = 'CHAT_CREATE_FAIL';

export const CHAT_MESSAGES_FETCH_REQUEST = 'CHAT_MESSAGES_FETCH_REQUEST';
export const CHAT_MESSAGES_FETCH_SUCCESS = 'CHAT_MESSAGES_FETCH_SUCCESS';
export const CHAT_MESSAGES_FETCH_FAIL = 'CHAT_MESSAGES_FETCH_FAIL';

export const CHAT_MESSAGE_SEND_REQUEST = 'CHAT_MESSAGE_SEND_REQUEST';
export const CHAT_MESSAGE_SEND_SUCCESS = 'CHAT_MESSAGE_SEND_SUCCESS';
export const CHAT_MESSAGE_SEND_FAIL = 'CHAT_MESSAGE_SEND_FAIL';

export const fetchChats = () => (dispatch, getState) => {
  dispatch(fetchChatsRequest());

  api(getState).get('/api/v1/chats').then(response => {
    const accounts = response.data.map(chat => chat.other_account).filter(Boolean);
    dispatch(importFetchedAccounts(accounts));
    dispatch(fetchChatsSuccess(response.data));
  }).catch(error => {
    dispatch(fetchChatsFail(error));
  });
};

export const fetchChatsRequest = () => ({
  type: CHATS_FETCH_REQUEST,
});

export const fetchChatsSuccess = chats => ({
  type: CHATS_FETCH_SUCCESS,
  chats,
});

export const fetchChatsFail = error => ({
  type: CHATS_FETCH_FAIL,
  error,
});

export const fetchChat = chatId => (dispatch, getState) => {
  dispatch(fetchChatRequest(chatId));

  api(getState).get(`/api/v1/chats/${chatId}`).then(response => {
    if (response.data.other_account) {
      dispatch(importFetchedAccounts([response.data.other_account]));
    }
    dispatch(fetchChatSuccess(response.data));
  }).catch(error => {
    dispatch(fetchChatFail(chatId, error));
  });
};

export const fetchChatRequest = chatId => ({
  type: CHAT_FETCH_REQUEST,
  chatId,
});

export const fetchChatSuccess = chat => ({
  type: CHAT_FETCH_SUCCESS,
  chat,
});

export const fetchChatFail = (chatId, error) => ({
  type: CHAT_FETCH_FAIL,
  chatId,
  error,
});

export const createChat = (accountId, e2ee = false) => (dispatch, getState) => {
  dispatch(createChatRequest());

  api(getState).post('/api/v1/chats', {
    account_id: accountId,
    e2ee: e2ee,
  }).then(response => {
    if (response.data.other_account) {
      dispatch(importFetchedAccounts([response.data.other_account]));
    }
    dispatch(createChatSuccess(response.data));
  }).catch(error => {
    dispatch(createChatFail(error));
  });
};

export const createChatRequest = () => ({
  type: CHAT_CREATE_REQUEST,
});

export const createChatSuccess = chat => ({
  type: CHAT_CREATE_SUCCESS,
  chat,
});

export const createChatFail = error => ({
  type: CHAT_CREATE_FAIL,
  error,
});

export const fetchChatMessages = chatId => (dispatch, getState) => {
  dispatch(fetchChatMessagesRequest(chatId));

  api(getState).get(`/api/v1/chats/${chatId}/messages`).then(response => {
    dispatch(fetchChatMessagesSuccess(chatId, response.data));
  }).catch(error => {
    dispatch(fetchChatMessagesFail(chatId, error));
  });
};

export const fetchChatMessagesRequest = chatId => ({
  type: CHAT_MESSAGES_FETCH_REQUEST,
  chatId,
});

export const fetchChatMessagesSuccess = (chatId, messages) => ({
  type: CHAT_MESSAGES_FETCH_SUCCESS,
  chatId,
  messages,
});

export const fetchChatMessagesFail = (chatId, error) => ({
  type: CHAT_MESSAGES_FETCH_FAIL,
  chatId,
  error,
});

export const sendChatMessage = (chatId, content, encrypted = false) => (dispatch, getState) => {
  dispatch(sendChatMessageRequest(chatId));

  const params = encrypted ? 
    { encrypted_content: content } : 
    { content };

  api(getState).post(`/api/v1/chats/${chatId}/messages`, params).then(response => {
    dispatch(sendChatMessageSuccess(chatId, response.data));
  }).catch(error => {
    dispatch(sendChatMessageFail(chatId, error));
  });
};

export const sendChatMessageRequest = chatId => ({
  type: CHAT_MESSAGE_SEND_REQUEST,
  chatId,
});

export const sendChatMessageSuccess = (chatId, message) => ({
  type: CHAT_MESSAGE_SEND_SUCCESS,
  chatId,
  message,
});

export const sendChatMessageFail = (chatId, error) => ({
  type: CHAT_MESSAGE_SEND_FAIL,
  chatId,
  error,
});
